import { currentFormat } from '@/utils/cases';
import { translates } from '@/utils/translate';
import { Card, CardContent, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';

export type DataFormat = {
  label: string;
  value: number;
};

type Props = {
  data?: DataFormat[];
  total: number;
};

export const CardDetailBar = ({ data, total }: Props) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const themes = [
    '#c180f0',
    '#db9863',
    '#180627',
    '#25aae3',
    '#1739d1',
    '#cc261b',
    '#d95518',
    '#80d117',
  ];
  const sortData = data?.sort((a, b) => b.value - a.value);
  const growSizes = sortData?.map((value) => Math.ceil((value.value / total) * 100));
  if (!data?.length) return null;
  return (
    <Card>
      <CardContent id="card" sx={{ display: 'flex', flexDirection: 'column' }}>
        <Stack>
          <Typography variant="h4">{currentFormat(total)}</Typography>
          <Typography variant="h5">Total</Typography>
          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              borderRadius: '5px',
              width: '100%',
              gap: 0.2,
            }}
          >
            {growSizes?.map((value, index) =>
              value ? (
                <span
                  key={index}
                  style={{
                    background: themes?.[index],
                    height: 10,
                    width: `${index < 1 ? value / 2 : value * 2}%`,
                    borderStyle: 'none',
                    borderRadius: '5px',
                  }}
                />
              ) : null
            )}
          </Stack>
          <Stack
            sx={{ display: 'flex', gap: '1rem' }}
            justifyContent="space-between"
            flexDirection={matches ? 'row' : 'column'}
          >
            {sortData?.map((currentData, index) => (
              <Stack key={index} sx={{ display: 'flex', flexDirection: 'row', gap: '0.5rem' }}>
                <svg
                  width={10}
                  viewBox="0 0 100 100"
                  fill={themes?.[index]}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="50" cy="50" r="50" />
                </svg>
                <Stack sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography variant={matches ? 'body1' : 'caption'}>
                    {translates[currentData.label]}
                  </Typography>
                  <Typography sx={{ fontSize: 10 }}>{currentFormat(currentData.value)}</Typography>
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
